/**
 * A deliberately simple product-import sample. The first line has one cell so
 * the existing spreadsheet reader skips it and finds the real header row next.
 * The sample row is visibly synthetic and should be replaced or removed.
 */
export const PRODUCT_IMPORT_TEMPLATE_HEADERS = [
  'sku',
  'upc',
  'product name',
  'size',
  'price',
  'sale price',
  'sale end date',
  'in stock',
  'store',
  'department',
  'category',
  'short description',
  'ingredients',
  'photo',
  'nutrition label',
  'spanish name',
  'spanish description',
] as const;

const SAMPLE = [
  'SAMPLE-001',
  '',
  'SAMPLE — replace or delete this row',
  '12 oz',
  '4.49',
  '',
  '',
  'yes',
  'Replace with your store name or number',
  'Grocery',
  'Tortillas',
  'Replace with a short shopper-facing description.',
  'Corn flour, water, salt.',
  'none',
  'none',
  'Nombre de ejemplo',
  'Descripción de ejemplo',
] as const;

function csvField(value: string): string {
  return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/** CSV opens as a spreadsheet and is accepted by the existing import flow. */
export function productImportTemplateCsv(instruction: string): string {
  const line = (cells: readonly string[]) => cells.map(csvField).join(',');
  return `\uFEFF${line([instruction])}\r\n${line(PRODUCT_IMPORT_TEMPLATE_HEADERS)}\r\n${line(SAMPLE)}\r\n`;
}

